import React from 'react';
import skewer from '../../images/bonskewer.png';
import khachapuri from '../../images/khachapuri.png';
import khinkali from '../../images/khinkali-round.png';
import MenuItem from './MenuItem';
/* SOUPS */
import soupchikhirtma from '../../images/m-chikhirtma.png';
import soupkharcho from '../../images/m-kharcho.png';
import soupkhashi from '../../images/m-khashi.png';
import soupsummerkhashlama from '../../images/m-summerkhashlama.png';
import soupxinkali from '../../images/khinka.PNG';
/* Cold dishes */
import assortedpkhila from '../../images/m-assortedpkhali.png';
import pkhilaa from '../../images/m-pkhali-b.png';
import pkhilab from '../../images/m-pkhali-b.png';
import pkhilac from '../../images/m-pkhali-c.png';
import eggplant from '../../images/m-eggplant.png';
import lobio from '../../images/m-lobio.png';
import assortedcheese from '../../images/m-assortedcheese.png';
import beetstkermali from '../../images/m-beetstkermali.png'
import salmonbaje from '../../images/salmon.jpg'
import redcaviar from '../../images/m-redcaviar.png'
import assortedmeat from '../../images/m-assortedmeat.png'
import satsivi from '../../images/m-satsivi.png';
import MenuItem2 from './MenuItem2';
import ovalbread from '../../images/ovalbread.jpg';

import {useTranslation } from "react-i18next";   
function Menu() {
  const { t, i18n } = useTranslation();

    return (
        <section id="menu" className="menu section-bg">
          <div className="container">                
            <div className="section-title">
              <h2>Menu</h2>
              <p>{t("menu-title")}</p>
            </div>  
            <div className="row">
            <div className="baniere-2 mb-1"></div> 
              <div className="col-lg-12 d-flex justify-content-center">                
                <ul className="nav nav-tabs ">
                  <li className="nav-item">
                    <a className="nav-link active show" data-bs-toggle="tab" href="#menu-1">{t("menu-nav-1")}</a>
                  </li>                 
                  <li className="nav-item">
                    <a className="nav-link" data-bs-toggle="tab" href="#menu-3">{t("menu-nav-2")}</a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" data-bs-toggle="tab" href="#menu-4">{t("menu-nav-3")}</a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" data-bs-toggle="tab" href="#menu-5">Salades</a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" data-bs-toggle="tab" href="#menu-6">{t("menu-nav-4")}</a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" data-bs-toggle="tab" href="#menu-7">Barbecue</a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" data-bs-toggle="tab" href="#menu-2">Khinkali</a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" data-bs-toggle="tab" href="#menu-8">{t("menu-nav-5")}</a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" data-bs-toggle="tab" href="#menu-9">{t("menu-nav-6")}</a>
                  </li>   
                  <li className="nav-item">
                    <a className="nav-link" data-bs-toggle="tab" href="#menu-10">Desserts</a>
                  </li>                 
                </ul>   
              </div>
              <div className="baniere-2 mt-1"></div> 
            </div>
                   
            {/* TAB CONTENT */}  
            <div className="col-lg-12 mt-4 mt-lg-0">
              <div className="tab-content">
                {/* TAB ONE */}  
                <div className="tab-pane active show" id="menu-1">
                    <div className="row pt-3">
                        <div className="center col-lg-4">
                            <h1 className='text-old'>{t("f-d-1-h")}</h1>
                            <img id='img-three' src={skewer} alt="Barbecue on a Skewer - Old Tbilisi"/>
                            <p id='p-description'>{t("f-d-1-p")}</p>
                            <hr id='p-description'></hr>                   
                        </div>
                        <div className="center col-lg-4">
                            <h1 className='text-old'>Khinkali</h1>
                            <img id='img-three' src={khinkali} alt="Khinkali - Old Tbilisi"/>
                            <p id='p-description'>{t("f-d-2-p")}</p>
                            <hr id='p-description'></hr>
                        </div>
                        <div className="center col-lg-4">
                            <h1 className='text-old'>Khachapuri</h1>
                            <img id='img-three' src={khachapuri} alt="Khinkali - Old Tbilisi"/>
                            <p id='p-description'>{t("f-d-3-p")}</p>
                            <hr id='p-description'></hr>                    
                        </div>
                    </div>
                </div>
                {/* TAB 2 - KHINKALI */}  
                <div className="tab-pane" id="menu-2">
                  <div className="row menu-container">
                    <MenuItem desc="" name={t("khinkali-1-h")} price="1.00"/>
                    <MenuItem desc="" name={t("khinkali-2-h")} price="1.00"/>
                    <MenuItem desc="" name={t("khinkali-3-h")} price="1.20"/>
                    <MenuItem desc="" name={t("khinkali-4-h")} price="1.00"/>
                    <MenuItem desc="" name={t("khinkali-5-h")} price="1.00"/>
                    <MenuItem desc="" name={t("khinkali-6-h")} price="1.00"/>
   
                  </div>
                </div>
                {/* TAB 3 - SOUPS */}  
                <div className="tab-pane" id="menu-3">
                  <div className="row menu-container">
                    <MenuItem2 desc={t("soups-1-p")} name="Kharcho" price="6.00" img={soupkharcho}/>
                    <MenuItem2 desc={t("soups-2-p")}name="Chikhirtma" price="5.00" img={soupchikhirtma}/>
                    <MenuItem2 desc="" name="Xinkali soup" price="7.00" img={soupxinkali}/>  
                    <MenuItem2 desc={t("soups-4-p")} name="Summer Khashlama" price="8.00" img={soupsummerkhashlama}/>
                    
                  </div>                  
                </div>
                {/* Tab 4 - Cold Dishes */}
                <div className="tab-pane" id="menu-4">
                  <div className="row menu-container">
                    <MenuItem2 desc={t("c-d-1-p")} name={t("c-d-1-h")} price="9.00" img={assortedpkhila}/>
                    <MenuItem2 desc={t("c-d-2-p")} name={t("c-d-2-h")} price="5.00" img={pkhilaa}/>
                    <MenuItem2 desc={t("c-d-3-p")} name={t("c-d-3-h")} price="7.00" img={pkhilab}/>
                    <MenuItem2 desc={t("c-d-4-p")} name={t("c-d-4-h")} price="4.00" img={pkhilac}/>
                    <MenuItem2 desc="" name={t("c-d-5-h")} price="7.00" img={eggplant}/>
                    <MenuItem2 desc={t("c-d-6-p")} name="Lobio" price="6.00" img={lobio}/>
                    <MenuItem2 desc={t("c-d-7-p")} name={t("c-d-7-h")} price="7.00" img={assortedcheese}/>
                    <MenuItem2 desc="" name={t("c-d-8-h")} price="4.50" img={beetstkermali}/>
                    <MenuItem2 desc={t("c-d-9-p")} name="Satsivi" price="8.00" img={satsivi}/>
                    <MenuItem2 desc={t("c-d-10-p")} name={t("c-d-10-h")} price="14.00" img={salmonbaje}/>
                    <MenuItem2 desc={t("c-d-11-p")} name={t("c-d-11-h")} price="6.00" img={redcaviar}/>
                    <MenuItem2 desc="" name={t("c-d-12-h")} price="14.50" img={assortedmeat}/>
                  </div>
                </div>
                {/* TAB 5 - Salades */}  
                <div className="tab-pane" id="menu-5">
                  <div className="row menu-container">
                    <MenuItem desc="" name={t("salades-1-h")} price="4.00"/>
                    <MenuItem desc={t("salades-2-p")} name={t("salades-2-h")} price="6.50"/>
                    <MenuItem desc="" name={t("salades-3-h")} price="7.00"/>
                    <MenuItem desc="" name={t("salades-4-h")} price="9.00"/>
                    <MenuItem desc="" name={t("salades-5-h")} price="6.00"/>
                    <MenuItem desc={t("salades-6-p")} name="Jonjoli" price="6.00"/>
                  
                  </div>
                </div>
                {/* TAB 6 - HOT DISHES */}  
                <div className="tab-pane" id="menu-6">
                  <div className="row menu-container">
                    <MenuItem desc={t("h-d-1-p")} name="Megruli Kharcho" price="12.00"/>
                    <MenuItem desc={t("h-d-2-p")} name="Chakapuli" price="12.00"/>
                    <MenuItem desc={t("h-d-3-p")} name="Chkmeruli" price="11.00"/>
                    <MenuItem desc={t("h-d-4-p")} name="Chashushuli" price="9.00"/>
                    <MenuItem desc={t("h-d-5-p")} name="Chakhokhbili" price="7.00"/>
                    <MenuItem desc={t("h-d-6-p")} name={t("h-d-6-h")} price="9.00"/>
                    <MenuItem desc={t("h-d-7-p")} name="Dolma" price="6.00"/>
                    <MenuItem desc={t("h-d-8-p")} name="Kuchmachi" price="5.00"/>
                    <MenuItem desc={t("h-d-9-p")} name={t("h-d-9-h")} price="9.50"/>
                    <MenuItem desc={t("h-d-10-p")} name={t("h-d-10-h")} price="9.00"/>
                    
                  </div>
                </div>
                {/* TAB 7 - Barbecue */}  
                <div className="tab-pane" id="menu-7">
                  <div className="row menu-container">
                  <MenuItem desc="" name={t("bbq-1-h")} price="11.00"/>
                  <MenuItem desc="" name={t("bbq-3-h")} price="12.00"/>
                  <MenuItem desc="" name={t("bbq-4-h")} price="13.50"/>
                  <MenuItem desc="" name={t("bbq-5-h")} price="14.00"/>
                  <MenuItem desc="" name={t("bbq-6-h")} price="8.00"/>
                  <MenuItem desc="" name={t("bbq-7-h")} price="8.00"/>
                  <MenuItem desc="" name={t("bbq-8-h")} price="6.00"/>
                  <MenuItem desc="" name={t("bbq-9-h")} price="9.00"/>
                  <MenuItem desc="" name={t("bbq-9-h-2")} price="11.00"/>
                  <MenuItem desc="" name={t("bbq-10-h")} price="8.00"/>
                  <MenuItem desc="" name={t("bbq-11-h")} price="10.00"/>
                  <MenuItem desc="" name={t("bbq-12-h")} price="10.00"/>
                  <MenuItem desc="" name={t("bbq-13-h")} price="9.00"/>
                  <MenuItem desc="" name={t("bbq-14-h")} price="6.00"/>
                  <MenuItem desc="" name={t("bbq-15-h")} price="18.50"/>
                  <MenuItem desc="" name={t("bbq-16-h")} price="8.00"/>
                  </div>
                </div>
                {/* TAB 8 - Sauces */} 
                <div className="tab-pane" id="menu-8">
                  <div className="row menu-container">
                    <MenuItem desc={t("sauces-1-p")} name={t("sauces-1-h")} price="1.00"/>
                    <MenuItem desc={t("sauces-2-p")} name={t("sauces-2-h")} price="1.00"/>
                    <MenuItem desc={t("sauces-3-p")} name="Adjika" price="1.00"/>
                    <MenuItem desc={t("sauces-4-p")} name={t("sauces-4-h")} price="1.00"/>
                  </div>
                </div> 
                {/* TAB 9 - Pastries */} 
                <div className="tab-pane" id="menu-9">
                  <div className="row menu-container">
                    <MenuItem desc={t("pastry-1-p")} name="Imeruli Khachapuri" price="9.00"/>
                    <MenuItem desc={t("pastry-2-p")} name="Megruli Khachapuri" price="10.50"/>
                    <MenuItem desc={t("pastry-3-p")} name="Royal Khachapuri" price="11.50"/>
                    <MenuItem2 img={ovalbread} desc={t("pastry-4-p")} name="Adjaruli Khachapuri" price="10.00"/>
                    <MenuItem desc={t("pastry-5-p")} name="Lobiani" price="6.00"/>
                    <MenuItem desc={t("pastry-6-p")} name="Kubdari" price="9.00"/>
                    <MenuItem desc="" name={t("pastry-7-h")} price="1.00"/>
                    <MenuItem desc={t("pastry-8-p")} name="Mchadi" price="1.00"/>
                    <MenuItem desc={t("pastry-9-p")} name="Kvichtari" price="3.00"/>

                     
                  </div>
                </div>  
                {/* TAB 10 - Desserts */}
                <div className="tab-pane" id="menu-10">
                  <div className="row menu-container">
                    <MenuItem desc="" name={t("dessert-1-h")} price="2.50"/>
                    <MenuItem desc="" name={t("dessert-2-h")} price="2.50"/>
                    <MenuItem desc="" name="Baklava" price="11.50"/>
                    <MenuItem desc="" name={t("dessert-4-h")} price="10.00"/>
                    <MenuItem desc="" name={t("dessert-5-h")} price="18.00"/>                    
                  </div>
                </div>     
              </div>
            </div>
            {/*DOWNLAOD MENU*/}
          <div  className="text-center pt-2">
            <a id="p-description" href="/OldTbilisi-Menu.pdf" download><span className="text-orange">{t("download-menu")} <i className="text-white fas fa-arrow-circle-down"></i></span></a>
            <p className="pt-2"><a href="https://www.takeaway.com/be-en/menu/old-tbilisi-georgisch-restaurant" rel="noreferrer" target="_blank">{t("about-us-p-3")}</a></p>
          </div>
 
          </div>
        </section>
    )
}

export default Menu;
